import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Paper,
  useMediaQuery,
  Divider,
  Alert,
  InputAdornment,
  Tabs,
  Tab
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import UserPageLayout from '../../components/user/UserPageLayout';
import { Person, Phone, Email, Lock, Visibility, VisibilityOff } from '@mui/icons-material';
import { signup } from '../../services/loginServices';
import { restaurantService } from '../../services/restaurantService';
import { useRestaurant } from '../../contexts/RestaurantContext';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import colors from '../../components/colors';

const GuestSignupPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();
  const { loginUser, setLoginUser } = useRestaurant()

  const taxDetails = location.state;
  const [isSignup, setIsSignup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({});
  const [restaurantData, setRestaurantData] = useState({})
  const [countryNoLength, setCountryNoLength] = useState(0)

  const serviceType = location.state?.serviceType || 'delivery';

  useEffect(() => {
    async function fetchRestaurantData() {
      try {
        const response = await restaurantService.getPublicRestaurantData()
        // console.log("Response => ", response);
        setRestaurantData(response)
      }
      catch (error) {
        // console.log("Error Happened", error);
      }
    }
    fetchRestaurantData();
  }, [])

  const handleNumberChange = (field, e) => {
    let phoneNumber_Length = e.target.countryValue.format.split('.').length - 1;
    setCountryNoLength(phoneNumber_Length)
    setForm({ ...form, phone: e.target.value })
  }

  const validateForm = () => {
    const newErrors = {};

    if (!form.name.trim()) newErrors.name = 'Name is required';

    if (!form.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (form.phone.trim().length !== countryNoLength) {
      // console.log("Hello")
      newErrors.phone = "Enter a Valid Phone Number"
    }



    if (isSignup) {
      if (!form.email.trim()) {
        newErrors.email = 'Email is required';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
        newErrors.email = 'Invalid email address';
      }

      if (!form.password.trim()) {
        newErrors.password = 'Password is required';
      } else if (form.password.length < 6) {
        newErrors.password = 'Password must be at least 6 characters';
      }

      if (form.password !== form.confirmPassword) {
        newErrors.confirmPassword = 'Passwords do not match';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleContinue = () => {
    if (validateForm()) {
      sessionStorage.setItem(
        'userInfo',
        JSON.stringify({
          name: form.name,
          phone: form.phone,
          email: isSignup ? form.email : '',
          isGuest: !isSignup
        })
      );

      navigate('/checkout', {
        state: {
          serviceType,
          userInfo: {
            name: form.name,
            phone: form.phone,
            email: isSignup ? form.email : '',
            isGuest: !isSignup
          },
          taxDetails
        }
      });
    }
  };



  const handleSignup = async () => {
    if (validateForm()) {
      try {
        let data = {
          username: form.name,
          password: form.password,
          c_password: form.confirmPassword,
          email: form.email,
          phone: form.phone
        };
        const response = await signup(data);
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('refresh_token', response.refresh_token);
        sessionStorage.setItem('user', JSON.stringify(response.user));
        setLoginUser(response.user);
        sessionStorage.setItem(
          'userInfo',
          JSON.stringify({
            name: form.name,
            phone: form.phone,
            email: form.email,
            isGuest: false
          })
        );

        navigate('/checkout', {
          state: {
            serviceType,
            userInfo: {
              name: form.name,
              phone: form.phone,
              email: form.email,
              isGuest: false
            }
          }
        });
      } catch (error) {

        console.error('Signup error:', error.message);
        setErrors({ general: error?.message });
      }
    }
  };

  const handleTabChange = (event, newValue) => {
    setIsSignup(newValue === 1);
  };

  return (
    <Box sx={{ mt: 18 }}>
      <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4, mb: 4, background: 'white', borderRadius: '20px', boxShadow: 10, }}>
        <Paper
          sx={{
            p: { xs: 3, sm: 4, md: 6 },
            pt: { md: 3 },
            pb: { md: 6 },
            // py:{md:3},
            borderRadius: '8px',
            background: 'white'
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <Box component="img" src={restaurantData.logo_url} sx={{
              width: '70px',
              height: '70px'
            }} /></Box>

          {/* Tab-style Toggle */}
          <Box sx={{ mb: 5 }}>
            <Tabs
              value={isSignup ? 1 : 0}
              onChange={handleTabChange}
              variant="fullWidth"
              sx={{
                '& .MuiTabs-indicator': {
                  backgroundColor: colors.primary.main,
                  // height: 3
                }
              }}
            >
              <Tab
                label="Continue as Guest"
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: { xs: '0.875rem', sm: '1rem', md: '14px !important' },
                  color: isSignup ? 'text.secondary' : colors.primary.main,
                  '&.Mui-selected': {
                    color: colors.primary.main,
                  }
                }}
              />
              <Tab
                label="Create Account"
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: { xs: '0.875rem', sm: '1rem', md: '14px !important' },
                  color: !isSignup ? 'text.secondary' : colors.primary.main,
                  '&.Mui-selected': {
                    color: colors.primary.main,
                  }
                }}
              />
            </Tabs>
          </Box>

          {errors.general && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {errors.general}
            </Alert>
          )}

          {/* Form Fields */}
          {/* <Grid container spacing={3}> */}
            <Grid item xs={12} sx={{mb:3}}>
              <TextField
                fullWidth
                label="Full Name *"
                value={form.name}
                onChange={(e) => {
                  setErrors({})
                  setForm({ ...form, name: e.target.value })
                }
                }
                error={!!errors.name}
                helperText={errors.name}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Person sx={{ color: colors.primary.main }} />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>

            <Grid item xs={12}>
              {/* <TextField
                fullWidth
                label="Phone Number *"
                value={form.phone}
                onChange={(e) => {
                  setErrors({})
                  setForm({ ...form, phone: e.target.value })
                }}
                error={!!errors.phone}
                helperText={errors.phone || 'Enter 8-digit SG phone (e.g., 81234567)'}
                placeholder="81234567"
                inputProps={{ maxLength: 8 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone sx={{ color: colors.primary.main }} />
                    </InputAdornment>
                  )
                }}
              /> */}

              <PhoneInput
                country="sg"
                specialLabel=""
                // autoFormat={false}
                value={form?.phone || ''}
                onChange={(phone, country) => handleNumberChange("phone", { target: { value: phone, countryValue: country } })}
                inputStyle={{
                  width: '100%',
                  height: '50.25px',
                  borderRadius: '7px',
                  color: 'black',
                  paddingLeft: '58px',
                  fontSize: '12px !important',
                }}
                buttonStyle={{
                  borderTopLeftRadius: '7px',
                  borderBottomLeftRadius: '7px',
                }}
                containerStyle={{
                  width: '100%',
                }}
                dropdownStyle={{
                  height: '120px',
                  overflowY: 'auto',
                  position: 'absolute', // Add this
                  zIndex: 1, // Add this to ensure dropdown appears above other content
                }}
              />
              {errors.phone && (
                <p style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px" }}>
                  {errors.phone}
                </p>
              )}
            </Grid>

            {isSignup && (
              <>
                <Grid item xs={12} sx={{mt:3}}>
                  <TextField
                    fullWidth
                    label="Email Address *"
                    type="email"
                    value={form.email}
                    onChange={(e) => {
                      setErrors({})
                      setForm({ ...form, email: e.target.value })
                    }}
                    error={!!errors.email}
                    helperText={errors.email}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email sx={{ color: colors.primary.main }} />
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} sx={{mt:3}}>
                  <TextField
                    fullWidth
                    label="Password *"
                    type={showPassword ? 'text' : 'password'}
                    value={form.password}
                    onChange={(e) => {
                      setErrors({})
                      setForm({ ...form, password: e.target.value })
                    }
                    }
                    error={!!errors.password}
                    helperText={errors.password}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Lock sx={{ color: colors.primary.main }} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button
                            onClick={() => setShowPassword(!showPassword)}
                            sx={{ minWidth: 'auto', p: 1, color: colors.primary.main }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </Button>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} sx={{mt:3}}>
                  <TextField
                    fullWidth
                    label="Confirm Password *"
                    type="password"
                    value={form.confirmPassword}
                    onChange={(e) =>
                      setForm({ ...form, confirmPassword: e.target.value })
                    }
                    error={!!errors.confirmPassword}
                    helperText={errors.confirmPassword}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Lock sx={{ color: colors.primary.main }} />
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
              </>
            )}
          {/* </Grid> */}

          <Divider sx={{ my: 4 }} />

          {/* Action Buttons */}
          <Box
            sx={{
              display: 'flex',
              gap: 3,
              flexDirection: { xs: 'column', sm: 'row' }
            }}
          >
            <Button
              fullWidth
              variant="outlined"
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                height: { xs: 48, sm: 52 },
                borderColor: colors.primary.main,
                color: colors.primary.main,
                '&:hover': {
                  bgcolor: 'rgba(104,0,0,0.08)',
                  borderColor: colors.primary.main
                }
              }}
            >
              Back to Cart
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={isSignup ? handleSignup : handleContinue}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                height: { xs: 48, sm: 52 },
                bgcolor: colors.primary.main,
                '&:hover': {
                  bgcolor: '#540000'
                }
              }}
            >
              {isSignup ? 'Create Account & Continue' : 'Continue as Guest'}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default GuestSignupPage;